<section class="news-list">

    <div class="container-redesign">

        <div class="news-list__grid">

            <article
                *ngFor="let article of articles; trackBy: trackByTitle"
                class="news-list__card"
                [class.news-list__card--featured]="article.featured">

                <div class="news-list__image">

                    <img
                        [src]="article.image"
                        [alt]="article.title">

                    <span class="news-list__category">

                        {{ article.category }}

                    </span>

                </div>

                <div class="news-list__content">

                    <div class="news-list__meta">

                        <span class="news-list__author">

                            {{ article.author }}

                        </span>

                        <span class="news-list__comments">

                            Comments ({{ article.comments }})

                        </span>

                    </div>

                    <h3 class="news-list__title">

                        {{ article.title }}

                    </h3>

                    <a
                        [routerLink]="article.route"
                        class="news-list__link">

                        <span>Read More</span>

                        <img
                            src="/assets/img/redesign/flecha.svg"
                            alt="">

                    </a>

                </div>

            </article>

        </div>

    </div>

</section>